module.exports = __webpack_public_path__ + "img/vodacom-fantasy-header.9bc35c5c.png";